import { supabase } from '@/lib/supabase'

// ── Admin player management ────────────────────────────────────────

export async function fetchPlayers({
  p_search_term = null,
  p_gender = null,
  p_sport_id = null,
  p_limit = 10,
  p_offset = 0,
}) {
  const { data, error } = await supabase.rpc('get_players', {
    p_search_term,
    p_gender,
    p_sport_id,
    p_limit,
    p_offset,
  })
  if (error) throw error
  return data
}

export async function updatePlayer(playerId, { name, gender, sport_id }) {
  const payload = {
    name,
    gender,
    updated_at: new Date().toISOString(),
  }
  if (sport_id !== undefined) payload.sport_id = sport_id
  const { error } = await supabase.from('players').update(payload).eq('id', playerId)
  if (error) throw error
}

export async function deletePlayer(playerId) {
  const { error } = await supabase
    .from('players')
    .delete()
    .eq('id', playerId)
  if (error) throw error
}

export async function insertPlayer({ name, gender, sport_id = null }) {
  const { error } = await supabase
    .from('players')
    .insert({ name, gender, sport_id })
  if (error) throw error
}

// ── Player typeahead / search ──────────────────────────────────────

export async function searchPlayers(search_term, { p_sport_id = null } = {}) {
  const { data, error } = await supabase.rpc('search_players', {
    search_term,
    p_sport_id,
  })
  if (error) throw error
  return data
}

export async function createOrGetPlayer({ player_name, player_gender, p_sport_id = null }) {
  const { data, error } = await supabase.rpc('create_or_get_player', {
    player_name,
    player_gender,
    p_sport_id,
  })
  if (error) throw error
  return data
}
